import React from 'react';
import { Navbar } from '../components/Navbar';
import { SupportUsPage } from '../components/SupportUsPage';
import { Footer } from '../components/Footer';
export const SupportUs = () => {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-2369" data-mp="ynzv2y2383sq">
      <Navbar data-id="element-2370" data-mp="ymexezkh84qn" />
      <SupportUsPage data-id="element-2371" data-mp="12q4k1jhlcc91" />
      <Footer data-id="element-2372" data-mp="12qmnp16l1sqz" />
    </div>;
};